module.exports = __webpack_public_path__ + "static/img/存@2x.f703569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/存@2x.png
// module id = ku9C
// module chunks = 192